<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 常见问题
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <el-header class="header-id">
          ID：
          <el-input v-model="listQuery.id"   style="width:216px;margin-right:20px"></el-input>问题类型：
          <el-select
            v-model="listQuery.type_id_array"
            style="width:216px;margin-right:20px"
            multiple
             filterable 
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item in typeArr"
              :key="item.id"
              :label="item.type_name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button class="filter-item" type="primary"  @click="handleSearch" icon="el-icon-search">搜索</el-button>
          <el-button class="filter-item" type="success"  @click="handleCreate">新增</el-button>
          <el-button class="filter-item" type="warning" @click="handleReset">重置</el-button>
        </el-header>
        <el-main>
          <el-table border v-loading="listLoading" :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="ID"/>
            <el-table-column prop="type_name" label="问题类型" />
            <el-table-column prop="question" label="问题" />
            <el-table-column prop="answer" label="答案" />
            <el-table-column prop="sort_number" label="顺序" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="edit(scope.row)" type="primary" icon="el-icon-edit">编辑</el-button>
                <el-button size="mini" @click="del(scope.row)"  type="danger" icon="el-icon-delete">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <pagination
            v-show="total>0"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="handleList"
          />

          <el-dialog :title="popupTitle " width="450px"  center :visible.sync="dialogFlag" :close-on-click-modal= addControl @close='closeDialog'>
            <el-form :model="formData">
              <el-form-item label="问题" :label-width="formLabelWidth">
                <el-input v-model="formData.question"   style="width:216px"></el-input>
              </el-form-item>
              <el-form-item label="答案" :label-width="formLabelWidth">
                <el-input v-model="formData.answer"   type="textarea" style="width:216px"></el-input>
              </el-form-item>
              <el-form-item label="展示顺序" :label-width="formLabelWidth">
                <el-input-number v-model="formData.sort_number" :min="1"></el-input-number>
              </el-form-item>
              <el-form-item label="问题类型" :label-width="formLabelWidth">
                <el-select v-model="formData.type_id"  filterable placeholder="问题类型">
                  <el-option
                    v-for="item in typeArr"
                    :key="item.id"
                    :label="item.type_name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeAdd">取 消</el-button>
              <el-button type="primary" @click="sure">确 定</el-button>
            </div>
          </el-dialog>
        </el-main>
      </div>
    </div>
  </div>
</template>

<script>
import {
  commonQuestion,
  getCommonQuestionType,
  commonQuestionPost,
  commonQuestionPut,
  commonQuestionDel
} from "@/api/work_question";
import Pagination from "@/components/pagination/index";

export default {
  components: { Pagination },
  name: "work_question_config",
  data() {
    return {
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 10,
        id: undefined,
        type_id_array: null
      },
      formData: {
        question: undefined,
        answer: undefined,
        type_id: undefined,
        sort_number: undefined,
        id: undefined
      },
      // 添加数据的缓存。
          addData:{},
          addCheck:0,

      popupTitle:"",
      dialogFlag: false,
      formLabelWidth: "120px",
      typeArr: [],
      commitType: undefined // 1.新增；2.修改
    };
  },
  created() {
    this.handleList();
    this.getTypes();
  },
   computed:{
    addControl(){
      let item = true;
      if(this.popupTitle  == "添加"){
        item = false;
      }
      return item;
    }
  },
  methods: {
    handleCreate() {
      this.popupTitle = "添加";
      for(let key in this.formData){
         this.formData[key] = "";
      }
      if(this.addCheck == 1){
        this.formData = JSON.parse(JSON.stringify(this.addData));
      }
      this.commitType = 1;
      this.dialogFlag = true;
    },
    handleSearch() {
      this.listQuery.page = 1;
      this.handleList();
    },
    handleReset() {
      this.listQuery.id = undefined;
      this.listQuery.type_id_array = null;
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.handleList();
    },
    async handleList() {
      this.listLoading = true;
      const r = await commonQuestion(this.listQuery);
      if (r.data.code !== 200) return;
      this.tableData = r.data.data.data;
      this.total = r.data.data.total;
      this.listLoading = false;
      this.listQuery.id = undefined;
      this.listQuery.type_id_array = null;
    },
    async getTypes() {
      const r = await getCommonQuestionType();
      if (r.data.code !== 200) return;
      this.typeArr = r.data.data;
    },
    removeAdd(){
      this.dialogFlag = false;
    },
    remove() {
      this.formData.question = undefined;
      this.formData.answer = undefined;
      this.formData.type_id = undefined;
      this.formData.sort_number = undefined;
      this.formData.id = undefined;
      this.dialogFlag = false;
    },
    async sure() {
      switch (this.commitType) {
        case 1:
          const data = {
            question: this.formData.question,
            answer: this.formData.answer,
            type_id: this.formData.type_id,
            sort_number: this.formData.sort_number
          };
          commonQuestionPost(data)
           .then(response =>{
             if(response.data.code == 200){
                this.$message.success(response.data.message);
                this.addCheck = 2;
                this.dialogFlag = false;
                this.handleList();
             }else{
                this.$message.error(response.data.message);
              }
           })
           .catch(error=>{})
          break;
        case 2:
          const r2 = await commonQuestionPut(this.formData);
          if (r2.data.code !== 200) return;
          break;
      }
      this.commitType = undefined;
      await this.handleList();
      this.remove();
    },
    closeDialog(){
        if(this.popupTitle  == "添加" && (this.addCheck == 0 || this.addCheck == 1)){
           this.addData = JSON.parse(JSON.stringify(this.formData));
             this.addCheck = 1;
        }
        if(this.popupTitle  == "添加" && this.addCheck == 2){
             this.addCheck = 0;
             this.addData = {};
        }
      },

    edit(row) {
      this.popupTitle = "编辑";
      this.formData.question = row.question;
      this.formData.answer = row.answer;
      this.formData.type_id = row.type_id;
      this.formData.sort_number = row.sort_number;
      this.formData.id = row.id;
      this.dialogFlag = true;
      this.commitType = 2;
    },
    async del(row) {
      const r = await commonQuestionDel(row.id);
      if (r.data.code !== 200) return;
      await this.handleList();
    }
  }
};
</script>

<style>
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
.header-id {
  font-size: 14px;
}
</style>